import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Collapse,
  Input,
  Row,
  Col,
  Space,
  Typography,
  Checkbox,
  Button,
  message,
} from "antd";
import {
  LockOutlined,
  PhoneOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import ResetPassword from "../../ResetPassword/UI/ResetPassword";
import "./MyProfile.css";
import { Title, CustomCard } from "../../Utils/UI/Text";
import { patchUser, getUser } from "../../Users/Application/Users.business";
import { getSelectedUserSelector } from "../../Users/Infrastructure/Users.reducer";
import Storage from "../../Data/Domain/Storage";
import { ModalEditConfirm } from "../../Utils/UI/Text";

const { Panel } = Collapse;
const { Text } = Typography;

const MiPerfil = () => {
  const user = useSelector(getSelectedUserSelector);
  const [cellphone, setCellphone] = useState("");
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [name, setName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userId = new Storage("id").getItem();
    if (userId) getUser(userId);
  }, []);

  useEffect(() => {
    if (user) {
      setName(user.name || "");
      setLastname(user.lastname || "");
      setEmail(user.email || "");
      setCellphone(user.cellphone || "");
      setMfaEnabled(user.mfa_enabled ?? false);
    }
  }, [user]);

  const isValidPhone = (value) => /^\+\d{2}\s?\d{7,}$/.test(value);

  const handleSaveCellphone = async () => {
    const userId = user?.id || new Storage("id").getItem();
    if (!isValidPhone(cellphone)) {
      message.error("Por favor ingresa un número válido (+52 1234567890)");
      return;
    }
    setLoading(true);
    try {
      const body = [{ op: "replace", path: "/cellphone", value: cellphone }];
      const success = await patchUser(userId, body);
      if (success)
        message.success("Número de celular actualizado correctamente");
      else message.warning("No se pudo actualizar el número");
    } catch {
      message.error("Error inesperado al actualizar el número");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleMFA = async (checked) => {
    const userId = user?.id || new Storage("id").getItem();
    setMfaEnabled(checked);
    try {
      const body = [{ op: "replace", path: "/mfa", value: checked }];
      const success = await patchUser(userId, body);
      if (success)
        message.success(
          `MFA ${checked ? "activado" : "desactivado"} correctamente`
        );
      else message.warning("No se pudo actualizar el MFA");
    } catch {
      message.error("No se pudo actualizar el MFA");
    }
  };

  const handleSavePersonalData = async () => {
    const userId = user?.id || new Storage("id").getItem();

    const updates = [];
    if (name.trim() && name.trim() !== user?.name) {
      updates.push({ op: "replace", path: "/name", value: name.trim() });
    }
    if (lastname.trim() && lastname.trim() !== user?.lastname) {
      updates.push({
        op: "replace",
        path: "/lastname",
        value: lastname.trim(),
      });
    }

    if (updates.length === 0) {
      message.info("No se detectaron cambios para guardar.");
      return;
    }

    ModalEditConfirm({
      title: "Editar datos personales",
      messageOnOk: "Datos personales actualizados correctamente",
      onConfirm: async () => {
        try {
          console.log("Enviando PATCH con:", updates);
          let success = true;

          if (updates.length === 2) {
            success = await patchUser(userId, updates);
          } else {
            for (const update of updates) {
              const result = await patchUser(userId, [update]);
              if (!result) success = false;
            }
          }

          if (success) {
            message.success("Datos personales actualizados correctamente");
            getUser(userId);
          } else {
            message.warning("No se pudieron actualizar los datos.");
          }
        } catch (error) {
          console.error("Error al actualizar:", error);
          message.error("Error al actualizar los datos personales.");
        }
      },
      onCancel: () => {},
    });
  };

  return (
    <>
      <Title children={"Mi Perfil"} />
      <CustomCard>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Collapse
            collapsible="icon"
            bordered={false}
            defaultActiveKey={["1"]}
            className="custom-collapse"
          >
            <Panel
              header={
                <span style={{ fontWeight: 500 }}>
                  <LockOutlined style={{ marginRight: 8, color: "#1677ff" }} />
                  Restablecer Contraseña
                </span>
              }
              key="1"
            >
              <ResetPassword />
            </Panel>
          </Collapse>

          <Collapse
            collapsible="icon"
            bordered={false}
            defaultActiveKey={["2"]}
            className="custom-collapse"
          >
            <Panel
              header={
                <span style={{ fontWeight: 500 }}>
                  <SafetyCertificateOutlined
                    style={{ marginRight: 8, color: "#52c41a" }}
                  />
                  Verificar Información
                </span>
              }
              key="2"
            >
              <div style={{ paddingTop: "1rem" }}>
                <h4
                  style={{
                    fontWeight: 600,
                    marginBottom: "1rem",
                    fontFamily: "MontserratRegular",
                  }}
                >
                  Datos Personales
                </h4>

                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12}>
                    <Input
                      placeholder="Nombre"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Col>
                  <Col xs={24} md={12}>
                    <Input
                      placeholder="Apellido"
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                    />
                  </Col>
                </Row>

                <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
                  <Col span={24}>
                    <Input
                      placeholder="Correo Electrónico"
                      value={email}
                      disabled
                      style={{
                        backgroundColor: "#f5f5f5",
                        color: "#888",
                        cursor: "not-allowed",
                      }}
                    />
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 20,
                  }}
                >
                  <Button
                    type="primary"
                    className="button-mfa-profile"
                    onClick={handleSavePersonalData}
                  >
                    GUARDAR DATOS
                  </Button>
                </div>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            collapsible="icon"
            bordered={false}
            className="custom-collapse"
          >
            <Panel
              header={
                <span style={{ fontWeight: 500 }}>
                  <PhoneOutlined style={{ marginRight: 8, color: "#faad14" }} />
                  Celular
                </span>
              }
              key="3"
            >
              <Text
                style={{
                  fontWeight: 500,
                  fontSize: "1rem",
                  display: "block",
                  marginBottom: "12px",
                  color: "#1a1a1a",
                }}
              >
                Número de Celular
              </Text>

              <Input
                placeholder="+52 2227541222"
                value={cellphone}
                onChange={(e) => setCellphone(e.target.value)}
                style={{ marginBottom: 16 }}
              />

              <Checkbox
                checked={mfaEnabled}
                disabled={!isValidPhone(cellphone)}
                onChange={(e) => handleToggleMFA(e.target.checked)}
                style={{ marginBottom: 20 }}
              >
                Habilitar MFA
              </Checkbox>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="primary"
                  className="button-mfa-profile"
                  loading={loading}
                  onClick={handleSaveCellphone}
                >
                  GUARDAR NÚMERO
                </Button>
              </div>
            </Panel>
          </Collapse>
        </Space>
      </CustomCard>
    </>
  );
};

export default MiPerfil;
